<script setup lang="ts">
import Header from '@/components/Header.vue';
import ModalFromBot from '@/components/Modal/ModalFromBot.vue';
import { useRoute } from 'vue-router';
import router from '@/router';
import _service from '@/service';
import { useAccountStore } from '@/stores/account';
import { countSecondsDuration, exportCanvasAsPNG, handleTime } from '@/utils';
import { transact } from '@/utils/transact';
import { Uploader, closeToast, showLoadingToast, showToast } from 'vant';
import QrcodeVue from 'qrcode.vue'
import { onMounted } from 'vue';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import clipboard3 from 'vue-clipboard3'
import { onUnmounted } from 'vue';
import moment from 'moment';
import { useConfigStore } from '@/stores/config';
import service from '@/service/service';
import ModalInMiddle from '@/components/Modal/ModalInMiddle.vue';
const { toClipboard } = clipboard3()
const route = useRoute()
const accountStore = useAccountStore()
const {t} = useI18n()
const productParams = ref<any>()
const defaultAddress = ref<any>()
const timer = ref<any>(null)
const isShowAddress = ref<boolean>(false)
const showFPSModal = ref<boolean>(false)
const timeCount = ref<any>('00:00:00')
const htmlPay = ref<any>('')
const showType = ref<any>('')
const countryOriginList = ref<any>([])
const fileList = ref<any>([])

const configStore = useConfigStore()

const copy = async (text:string) => {
  await toClipboard(text)
  showToast(t('Copied'))
}

const getOrderData = (code:string) => {
  switch (code) {
    case 'allinpay_cnp':
      return {
        id:productParams.value.id,
        channelCode: productParams.value.payChannel,
        channelExtras: {
          currency: productParams.value.coin,
          email: defaultAddress.value.email,
          billingFirstName: defaultAddress.value.firstName,
          billingLastName: defaultAddress.value.lastName,
          billingAddress1:defaultAddress.value.address1,
          billingCity: defaultAddress.value.city,
          billingCountry: defaultAddress.value.country,
          billingState: defaultAddress.value.state,
          billingZipCode: defaultAddress.value.zipCode,
          billingPhone: defaultAddress.value.phone,
          product: JSON.stringify([{
            sku:productParams.value.sku,
            productName:productParams.value.productName,
            price:productParams.value.price,
            quantity:productParams.value.quantity
          }])
        },
        displayMode:'url',
        returnUrl:`${window.location.origin}/payment`
      }
      break;
    case 'allinpay_alipay':
    return {
        id:productParams.value.id,
        channelCode:productParams.value.payChannel,
        channelExtras: {
          goodsInfo: `${productParams.value.productName}^${productParams.value.quantity}`,
          referUrl:`${window.location.origin}/payment`
        },
        displayMode:'url',
        returnUrl:`${window.location.origin}/payment`
      }
      break;
    default:
      break;
  }
}

const payFn = async() => {
  showLoadingToast({
    message: t("Loading"),
    duration: 0,
  });
  console.log('pay');
  const orderData = getOrderData(productParams.value.payChannel)
  const res:any = await _service.submitOrder(orderData)
  console.log(res.data,'res.data');
  if (import.meta.env.DEV && productParams.value.payChannel === 'allinpay_alipay') {
    res.data = {
      displayMode:'url',
      displayContent:"{\"secondary_merchant_industry\":\"7929\",\"payment_inst\":\"ALIPAYCN\",\"method\":\"post\",\"_input_charset\":\"UTF-8\",\"subject\":\"STAR NEST TECHNOLOGY HONG KONG LIMITED1\",\"refer_url\":\"192.168.31.124:5173\",\"sign\":\"430dc7c0f683e750ac61b5371821da93\",\"body\":\"TEST\",\"notify_url\":\"https://oats.allinpay.com/notify/notify/alipayNotify\",\"product_code\":\"NEW_WAP_OVERSEAS_SELLER\",\"secondary_merchant_id\":\"888000000015379336\",\"out_trade_no\":\"2024082623971938\",\"partner\":\"2088531875065060\",\"timeout_rule\":\"3m\",\"service\":\"create_forex_trade_wap\",\"trade_information\":\"{\\\"goods_info\\\":\\\"STAR^12\\\",\\\"business_type\\\":\\\"4\\\"}\",\"total_fee\":\"0.08\",\"secondary_merchant_name\":\"STAR NEST TECHNOLOGY HONG KONG LIMITED1\",\"return_url\":\"http://192.168.31.124:5173/pay-success\",\"action\":\"https://api-sea-global.alipayplus.com/gateway.do?_input_charset=UTF-8\",\"currency\":\"HKD\",\"sign_type\":\"MD5\"}"
    }
  }
  if (res.data) {
    if (res.data.displayMode === 'url') {
      window.location.href = res.data.displayContent
    }
    if(res.data.displayMode === 'form'){
      const _data = JSON.parse(res.data.displayContent)
      console.log(_data,'_data');
      sessionStorage.setItem('BACK_PARAMS',JSON.stringify(_data))
      const {action,method,...form} = _data
      document.querySelector('#alipaysubmit')?.setAttribute('action',action)
      document.querySelector('#alipaysubmit')?.setAttribute('method',method)
      for (const key in form) {
        const value = form[key];
        (document.querySelector(`input[name=${key}]`) as any).setAttribute('value',value)
        console.log(document.querySelector(`input[name=${key}]`),'form');
      }
      console.log(document.querySelector('#alipaysubmit'));
      document.forms['alipaysubmit'].submit();
    }
  }else{
    showToast(res.msg)
  }
  
}

const getAddressDefault = async() => {
  const {data}:any = await _service.getAddressList({})
  if (data.length) {
    const defaultData = data.filter((item:any)=>{
      return item.isDefault
    })[0]
    console.log(countryOriginList.value,'countryOriginList');
    
    defaultData.countryText = countryOriginList.value.filter((item:any)=>{
      return item.code === defaultData.country
    })[0].label
    defaultAddress.value = defaultData

  }else{
    defaultAddress.value = ''
  }
  
}

onMounted(async()=>{
  const params:any = route.query.params || ''
  // if (!sessionStorage.getItem('PAYMENT_DATA')) {
  //   sessionStorage.setItem('PAYMENT_DATA',params)
  //   const url = `${window.location.origin}${window.location.pathname}`
  //   window.location.href = url
  //   return false
  // }
  // const PAYMENT_DATA:any = sessionStorage.getItem('PAYMENT_DATA')
  productParams.value = JSON.parse(params)
  console.log(productParams.value);
  
  if (productParams.value.payChannel === 'allinpay_cnp') {
    showLoadingToast({
      message: t("Loading"),
      duration: 0,
    });
    if (!configStore.getCounrtryList.length) {
      countryOriginList.value = await configStore.getOriginCountry()
    }
    countryOriginList.value = configStore.getCounrtryList
    isShowAddress.value = true
    getAddressDefault()
    closeToast()
  }
  timer.value = setInterval(() => {
    timeCount.value = countSecondsDuration(productParams.value.expireTime) ? countSecondsDuration(productParams.value.expireTime) : '00:00'
  }, 1000);
})

onUnmounted(()=>{
  clearInterval(timer.value)
})

const uploadFile = async(data:any) => {
  let file = data.file
  // 此时可以自行将文件上传至服务器
  let fileName = file.name;  // 保存文件名
  let fileName2 = fileName.split('.');  // 对文件名进行切割
  //var renameFile =new File([原文件], 新文件名,文件类型);
  var renameFile =new File([file], `${showType.value}-${productParams.value.no}` + '.' + fileName2[1],{type:file.type});

  var formdata = new FormData();
  formdata.append('file', renameFile);
  try {
    data.status = 'uploading';
    data.message = '上傳中...';
    const res = await _service.uploadOrderImg(formdata)
    // fileList.value.push(data.origin_url)
    data.status = '';
    data.message = '';
  } catch (error) {
    console.log(error);
    
  }
}

</script>

<template>
  <div class="payment-layout">
    <div class="media-375">
      <div class="pay-detail">
        <div class="unpaid"></div>
        <div class="price">
          <div class="flex-row-start-center">{{t('Waiting for payment')}}: <span class="number-font"> {{productParams?.price * productParams?.quantity}} {{productParams?.coin}}</span></div>
          <div class="tip" v-if="productParams?.expireTime > new Date().getTime()">{{ t('Please complete the payment within time as soon as possible',{time:timeCount}) }}</div>
          <div class="tip" v-else>{{t('Expired')}}</div>
        </div>
        <div class="info flex-row-between-center">
          <span class="title">{{t('Order ID')}}</span>
          <span class="ct flex-row-start-center">{{productParams?.no}} <span class="copy" @click="copy(productParams?.id)"></span></span>
        </div>
        <div class="info flex-row-between-center">
          <span class="title">{{t('Order total')}}</span>
          <span class="ct">{{productParams?.price * productParams?.quantity}} {{productParams?.coin}}</span>
        </div>
        <div class="info flex-row-between-center">
          <span class="title">{{t('Order time')}}</span>
          <span class="ct">{{moment(productParams?.createTime).format('YYYY-MM-DD HH:mm:ss')}}</span>
        </div>
        <div class="info flex-row-between-center">
          <span class="title">{{t('Payment method')}}</span>
          <span class="ct">{{productParams?.payChannel}}</span>
        </div>
        <div class="info flex-row-between-start" v-if="isShowAddress">
          <span class="title">{{t('Billing address')}}</span>
          <span class="ct flex-row-start-start"> 
            <template v-if="defaultAddress">
              <span class="default">Default</span> <span class="address-text">{{defaultAddress?.countryText}} {{defaultAddress?.state}} {{defaultAddress?.city}}{{ defaultAddress?.address1 }}</span>
            </template>
            <div class="red" v-else>{{t('No address filled in yet')}}</div>
          </span>
        </div>
        <div class="info flex-row-end-center" v-if="isShowAddress">
          <router-link to="/address-list" class="address-btn">{{t('Switch address')}}</router-link>
        </div>
      </div>
      <!-- <Stripe></Stripe> -->
      <div class="bottom-area media-375-fixed">
        <!-- <template v-if="productParams?.payChannel === 'allinpay_cnp'">
          <div class="bottom-btn" :class="{'disabled':productParams?.expireTime < new Date().getTime()}" @click="()=>{
            fileList = []
            showType = 'payme'
            showFPSModal = true
          }">Payme支付</div>
          <div class="bottom-btn" :class="{'disabled':productParams?.expireTime < new Date().getTime()}" @click="()=>{
            fileList = []
            showType = 'fps'
            showFPSModal = true
          }">FPS數轉快支付</div>
          <div class="bottom-btn" :class="{'disabled':productParams?.expireTime < new Date().getTime() || (isShowAddress && !defaultAddress)}" @click="payFn">信用卡支付</div>
        </template> -->
        <div class="bottom-btn" :class="{'disabled':productParams?.expireTime < new Date().getTime() || (isShowAddress && !defaultAddress)}" @click="payFn">{{ t('Pay') }}</div>
      </div>
    </div>
    <ModalInMiddle v-model:is-show="showFPSModal" :title="showType === 'fps' ? `FPS數轉快支付` : `Payme支付`">
      <div class="confirm-modal">
        <div class="ct flex-col-center-center">
          <div class="number-font">{{productParams?.price * productParams?.quantity}} {{productParams?.coin}}</div>
          <img src="../../assets/fps.jpg" alt="" v-if="showType === 'fps'">
          <img src="../../assets/payme.jpg" alt="" v-else>
        </div>
        <div class="flex-col-center-center">
          <Uploader class="uploader" :name="productParams?.no" v-model="fileList" :show-upload="!fileList.length"  upload-text="上傳支付憑證" :after-read="uploadFile" />
        </div>
        <div class="btn-group flex-row-between-center">
          <div class="btn  flex-row-center-center"  @click="()=>{
             if (!fileList.length) {
              showToast('请上傳支付憑證')
              return false
             }
             showToast('提交成功，請稍後查看訂單')
             showFPSModal = false
          }">我已上傳</div>
          <div class="btn gray flex-row-center-center" @click="showFPSModal = false">返回</div>
        </div>
      </div>
    </ModalInMiddle>
    <form id="alipaysubmit" name="alipaysubmit" action="" method="">
      <input type="hidden" name="secondary_merchant_industry" value=""/>
      <input type="hidden" name="payment_inst" value=""/>
      <input type="hidden" name="_input_charset" value=""/>
      <input type="hidden" name="subject" value=""/>
      <input type="hidden" name="refer_url" value=""/>
      <input type="hidden" name="sign" value=""/>
      <input type="hidden" name="body" value=""/>
      <input type="hidden" name="notify_url" value=""/>
      <input type="hidden" name="product_code" value=""/>
      <input type="hidden" name="secondary_merchant_id" value=""/>

      <input type="hidden" name="out_trade_no" value=""/>
      <input type="hidden" name="partner" value=""/>
      <input type="hidden" name="timeout_rule" value=""/>
      <input type="hidden" name="service" value=""/>
      <input type="hidden" name="supplier" value=""/>
      <input type="hidden" name="total_fee" value=""/>
      <input type="hidden" name="secondary_merchant_name" value=""/>
      <input type="hidden" name="return_url" value=""/>
      <input type="hidden" name="currency" value=""/>
      <input type="hidden" name="sign_type" value=""/>
      <input type="hidden" name="trade_information" value=""/>
      <input type="submit" value="支付宝支付" style="display:none;">
	  </form>
  </div>
</template>

<style lang="scss" scoped>
.payment-layout{
  height: 100%;
  min-height: 100vh;
  background: #070B14;
  padding: 0 12px;
  padding-top: 28px;
  overflow-y: scroll;
  .pay-detail{
    position: relative;
    border-radius: 12px;
    background:  #303342;
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 18px;
    .unpaid{
      position: absolute;
      top: -24px;
      right: -12px;
      width: 88px;
      height: 88px;
      background: url(../../assets/unpaid.svg);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
    .price{
      color: #FF3456;
      font-size: 16px;
      font-weight: 500;
      .number-font{
        font-size: 21px;
        font-weight: 700;
        margin-left: 10px;
      }
      .tip{
        font-size: 12px;
        font-weight: 400;
        margin-top: 6px;
      }
    }
    .info{
      width: 100%;
      font-size: 14px;
      line-height: 1.5;
      .title{
        color: #9C9CAA;
      }
      .ct{
        max-width: 218px;
        color: #fff;
        line-height: 1.4;
        text-align: right;
        .copy{
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url(../../assets/payment-copy.svg);
          background-size: contain;
          background-repeat: no-repeat;
          margin-left: 4px;
        }
        &.empty{
          color: #E43F5A;
        }
        .default{
          border-radius: 4px;
          border: 1px solid #1CF2E4;
          display: inline-flex;
          padding: 2px 4px;
          justify-content: center;
          align-items: center;
          color:  #1CF2E4;
          font-size: 8px;
          margin-top: 2px;
          margin-right: 4px;
        }
        .red{
          font-size: 14px;
          color: #E43F5A;
        }
        .address-text{
          word-break: break-all;
          @include multi-line-ellipsis(2)
        }
      }
    }
    .address-btn{
      border-radius: 100px;
      background: linear-gradient(111deg, #FFF853 4.98%, #6EEF94 56.05%, #2AD8CD 95.37%);
      display: flex;
      padding: 8px 12px;
      justify-content: center;
      align-items: center;
      gap: 4px;
      color: #000;
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;
    }
  }
}
.confirm-modal{
  .ct{
    img{
      width: 250px;
    }
    .number-font{
      font-weight: 700;
      font-size: 18px;
      margin-bottom: 12px;
      color: #E43F5A;
    }
  }
  .uploader{
    margin-bottom: 12px;
    :deep(.van-uploader__upload){
      border-radius: 12px;
    }
  }
}
</style>

